import Swiper from 'swiper';
import {Controller, Navigation} from 'swiper/modules';

const process = () => {
    // Register necessary Swiper modules
    Swiper.use([Controller, Navigation]);

    // Get pagination number button objects
    const paginationNumbers = document.querySelectorAll('.js-process-number button');


    // Initialize Image and Text slider
    const imagesSliders = new Swiper('.js-process-slider__images', {
        slidesPerView: 1,
        loop: true,
        navigation: {
            nextEl: '.swiper-process-next',
            prevEl: '.swiper-process-prev',
        },
    });

    const textSliders = new Swiper('.js-process-slider__text', {
        slidesPerView: 1,
        loop: true,
    });

    // Make sure the two slider control each other (so they are on the same index all the time)
    textSliders.controller.control = imagesSliders;
    imagesSliders.controller.control = textSliders;

    // Function to make the pagination buttons clickable and let them navigate to the right slide index
    paginationNumbers.forEach((button: HTMLElement) => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            imagesSliders.slideToLoop(button.dataset.slideIndex ? (parseInt(button.dataset.slideIndex) - 1) : 0);
        });
    });

    // When the slide index change, update the active state of the pagination number
    imagesSliders.on('slideChange', function (slider) {
        paginationNumbers.forEach((pageNumber: HTMLElement) => {
            pageNumber.classList.remove('is-active');

            if (pageNumber.dataset.slideIndex && (parseInt(pageNumber.dataset.slideIndex) === (slider.realIndex + 1))) {
                pageNumber.classList.add('is-active');
            }
        })
    });
};

export {process as default};
